import BetslipTextKeys from '~/components/sportsbook/lobby/features/betslip/sportsbook-betslip-text-keys';
import { BetslipBetError, BetslipBetErrorType, BetslipLimitation } from './sportsbook-betslip-types';

const ERROR_WARNING_TYPE_TO_TEXT_KEY_MAP = {
	[BetslipBetErrorType.UNAVAILABLE]: BetslipTextKeys.GENERAL_ERROR,
	[BetslipBetErrorType.ITEM_UNAVAILABLE]: BetslipTextKeys.ODDS_UNAVAILABLE,
	[BetslipBetErrorType.STAKE_TOO_LOW]: BetslipTextKeys.MINIMUM_STAKE_LABEL,
	[BetslipBetErrorType.STAKE_TOO_HIGH]: BetslipTextKeys.STAKE_TOO_HIGH,
	[BetslipBetErrorType.EVENT_LIMIT_EXCEEDED]: BetslipTextKeys.EVENT_LIMIT_EXCEEDED,
	[BetslipBetErrorType.MARKET_LIMIT_EXCEEDED]: BetslipTextKeys.MARKET_LIMIT_EXCEEDED,
	[BetslipBetErrorType.MARKET_LOSS_LIMIT_EXCEEDED]: BetslipTextKeys.MARKET_LOSS_LIMIT_EXCEEDED,
	[BetslipBetErrorType.SELECTION_LIMIT_EXCEEDED]: BetslipTextKeys.SELECTION_LIMIT_EXCEEDED,
	[BetslipBetErrorType.COMBO_NOT_ALLOWED]: BetslipTextKeys.COMBO_NOT_POSSIBLE,
	[BetslipBetErrorType.NON_COMBINABLE_SELECTIONS]: BetslipTextKeys.COMBO_NOT_POSSIBLE,
	[BetslipBetErrorType.INVALID_BONUS]: BetslipTextKeys.INVALID_BONUS,
	[BetslipBetErrorType.INVALID_BONUS_STAKE_TOO_LOW]: BetslipTextKeys.INVALID_BONUS_STAKE_TOO_LOW,
	[BetslipBetErrorType.INVALID_BONUS_STAKE_TOO_HIGH]: BetslipTextKeys.INVALID_BONUS_STAKE_TOO_HIGH,
	[BetslipBetErrorType.ITEM_COUNT_TOO_LOW]: BetslipTextKeys.ITEM_COUNT_TOO_LOW,
	[BetslipBetErrorType.ITEM_COUNT_TOO_HIGH]: BetslipTextKeys.ITEM_COUNT_TOO_HIGH,
	[BetslipBetErrorType.ODDS_TOO_LOW]: BetslipTextKeys.ODDS_TOO_LOW,
	[BetslipBetErrorType.ODDS_TOO_HIGH]: BetslipTextKeys.ODDS_TOO_HIGH,
	[BetslipBetErrorType.PLAYER_BALANCE_TOO_LOW]: BetslipTextKeys.NOT_ENOUGH_FUNDS,
	[BetslipBetErrorType.PLAYER_NEEDS_MORE_VERIFICATION_TO_PLACE_BET]:
		BetslipTextKeys.PLAYER_NEEDS_MORE_VERIFICATION_TO_PLACE_BET,
	[BetslipBetErrorType.PLAYER_STAKE_LIMIT_REACHED]: BetslipTextKeys.STAKE_LIMIT_REACHED,
	[BetslipBetErrorType.PLAYER_LOSS_LIMIT_REACHED]: BetslipTextKeys.LOSS_LIMIT_REACHED,
	[BetslipBetErrorType.ODDS_UPDATED]: BetslipTextKeys.ODDS_UPDATED,
	[BetslipBetErrorType.STAKE_HIGHER_THAN_WIN]: BetslipTextKeys.STAKE_HIGHER_THAN_WIN,
	[BetslipBetErrorType.OTHER]: BetslipTextKeys.GENERAL_ERROR,
	[BetslipBetErrorType.PLAYER_AUTH_FAILED]: BetslipTextKeys.GENERAL_ERROR,
	[BetslipBetErrorType.PLAYER_BET_LIMIT_PER_DAY_EXCEEDED]: BetslipTextKeys.SEAMLESS_ERROR_LIMIT_DAY_BET_EXEEDED,
	[BetslipBetErrorType.PLAYER_BET_LIMIT_PER_WEEK_EXCEEDED]: BetslipTextKeys.SEAMLESS_ERROR_LIMIT_WEEK_BET_EXEEDED,
	[BetslipBetErrorType.PLAYER_BET_LIMIT_PER_MONTH_EXCEEDED]: BetslipTextKeys.SEAMLESS_ERROR_LIMIT_MONTH_BET_EXEEDED,
	[BetslipBetErrorType.PLAYER_TIME_LIMIT_MISSING]: BetslipTextKeys.SEAMLESS_ERROR_MISSING_TIME_LIMIT,
	[BetslipBetErrorType.PLAYER_TIME_LIMIT_PER_DAY_EXCEEDED]: BetslipTextKeys.SEAMLESS_ERROR_DAILY_TIME_LIMIT_EXEEDED,
	[BetslipBetErrorType.PLAYER_TIME_LIMIT_PER_WEEK_EXCEEDED]: BetslipTextKeys.SEAMLESS_ERROR_WEEKLY_TIME_LIMIT_EXEEDED,
	[BetslipBetErrorType.PLAYER_TIME_LIMIT_PER_MONTH_EXCEEDED]:
		BetslipTextKeys.SEAMLESS_ERROR_MONTHLY_TIME_LIMIT_EXEEDED,
	[BetslipBetErrorType.PLAYER_IN_COOL_OFF_TIME]: BetslipTextKeys.SEAMLESS_ERROR_RC_COOLOFF,
	[BetslipBetErrorType.PLAYER_AGE_NOT_VERIFIED]: BetslipTextKeys.AGE_NOT_VERIFIED,
	[BetslipBetErrorType.LUGAS_ACTIVE_ON_OTHER_OPERATOR]: BetslipTextKeys.LUGAS_ACTIVE_ON_OTHER_OPERATOR,
	[BetslipBetErrorType.LUGAS_ON_SITE_COOLOFF]: BetslipTextKeys.LUGAS_ON_SITE_COOLOFF,
	[BetslipBetErrorType.LUGAS_ACTIVE_ON_CURRENT_OPERATOR]: BetslipTextKeys.LUGAS_ACTIVE_ON_CURRENT_OPERATOR,
	[BetslipBetErrorType.PLAYER_STATUS_GAMEPLAY_BLOCKED]: BetslipTextKeys.PLAYER_STATUS_GAMEPLAY_BLOCKED,
	[BetslipBetErrorType.SPORTSBOOK_PRODUCT_BLOCKED]: BetslipTextKeys.SPORTSBOOK_PRODUCT_BLOCKED,
	[BetslipBetErrorType.BALANCE_LIMIT_EXCEEDED]: BetslipTextKeys.BALANCE_LIMIT_EXCEEDED,
	[BetslipBetErrorType.REALITY_CHECK_LIMIT_EXCEEDED]: BetslipTextKeys.REALITY_CHECK_LIMIT_EXCEEDED
};

const COMBINATION_ERROR_TYPES = [BetslipBetErrorType.COMBO_NOT_ALLOWED, BetslipBetErrorType.NON_COMBINABLE_SELECTIONS];
const UNAVAILABLE_ERROR_TYPES = [
	BetslipBetErrorType.UNAVAILABLE,
	BetslipBetErrorType.ITEM_UNAVAILABLE,
	BetslipBetErrorType.OTHER
];

const ERROR_TYPES_TO_DISPLAY_ON_BET_OR_BET_ITEM = [
	BetslipBetErrorType.UNAVAILABLE,
	BetslipBetErrorType.ITEM_UNAVAILABLE,
	BetslipBetErrorType.OTHER,
	BetslipBetErrorType.INVALID_BONUS,
	BetslipBetErrorType.INVALID_BONUS_STAKE_TOO_LOW,
	BetslipBetErrorType.INVALID_BONUS_STAKE_TOO_HIGH,
	BetslipBetErrorType.STAKE_TOO_LOW,
	BetslipBetErrorType.STAKE_TOO_HIGH,
	BetslipBetErrorType.EVENT_LIMIT_EXCEEDED,
	BetslipBetErrorType.MARKET_LIMIT_EXCEEDED,
	BetslipBetErrorType.MARKET_LOSS_LIMIT_EXCEEDED,
	BetslipBetErrorType.SELECTION_LIMIT_EXCEEDED,
	BetslipBetErrorType.STAKE_HIGHER_THAN_WIN,
	BetslipBetErrorType.ODDS_TOO_LOW,
	BetslipBetErrorType.ODDS_TOO_HIGH,
	BetslipBetErrorType.NON_COMBINABLE_SELECTIONS,
	BetslipBetErrorType.SPORTSBOOK_PRODUCT_BLOCKED,
	BetslipBetErrorType.REALITY_CHECK_LIMIT_EXCEEDED
];

const LIMITATIONS_TO_DISPLAY = [
	// Specific limitation
	BetslipLimitation.UNAUTHORIZED_USER_ERROR,
	BetslipLimitation.BALANCE_TOO_LOW_ERROR,
	BetslipLimitation.PRODUCT_BALANCE_TOO_LOW_ERROR,
	BetslipLimitation.BETSLIP_CHANGES_NOT_ACCEPTED,
	BetslipLimitation.NOT_COMBINABLE_GROUP,
	BetslipLimitation.BET_HAS_AN_ERROR,
	BetslipLimitation.LOCATION_NOT_SHARED,
	BetslipLimitation.LOCATION_PENDING,
	BetslipLimitation.LOCATION_DENIED,
	BetslipLimitation.LOCATION_ERROR
];

export const BET_ERROR_TYPES_TO_DISPLAY = [
	BetslipBetErrorType.ITEM_COUNT_TOO_HIGH,
	BetslipBetErrorType.PLAYER_BALANCE_TOO_LOW,
	BetslipBetErrorType.PLAYER_STAKE_LIMIT_REACHED,
	BetslipBetErrorType.PLAYER_LOSS_LIMIT_REACHED,
	BetslipBetErrorType.PLAYER_BET_LIMIT_PER_DAY_EXCEEDED,
	BetslipBetErrorType.PLAYER_BET_LIMIT_PER_WEEK_EXCEEDED,
	BetslipBetErrorType.PLAYER_BET_LIMIT_PER_MONTH_EXCEEDED,
	BetslipBetErrorType.PLAYER_TIME_LIMIT_MISSING,
	BetslipBetErrorType.PLAYER_TIME_LIMIT_PER_DAY_EXCEEDED,
	BetslipBetErrorType.PLAYER_TIME_LIMIT_PER_WEEK_EXCEEDED,
	BetslipBetErrorType.PLAYER_TIME_LIMIT_PER_MONTH_EXCEEDED,
	BetslipBetErrorType.PLAYER_AUTH_FAILED,
	BetslipBetErrorType.PLAYER_STATUS_GAMEPLAY_BLOCKED
];

export const getBetslipBetErrorTranslationKey = (errorType: BetslipBetErrorType): string => {
	const textKey = ERROR_WARNING_TYPE_TO_TEXT_KEY_MAP[errorType];
	return textKey || BetslipTextKeys.GENERAL_ERROR;
};

export const isCombinationErrorType = (errorType: BetslipBetErrorType): boolean =>
	COMBINATION_ERROR_TYPES.some(combinationErrorType => errorType === combinationErrorType);
export const isCombinationError = (error: BetslipBetError): boolean => isCombinationErrorType(error.type);

export const isUnavailableErrorType = (errorType: BetslipBetErrorType): boolean =>
	UNAVAILABLE_ERROR_TYPES.some(combinationErrorType => errorType === combinationErrorType);
export const isUnavailableError = (error: BetslipBetError): boolean => isUnavailableErrorType(error.type);

/**
 * Retrieve if error should get a feedback on bet level.
 */
export const isBetNeedToFeedbackAnError = (error: BetslipBetError): boolean =>
	ERROR_TYPES_TO_DISPLAY_ON_BET_OR_BET_ITEM.includes(error.type);

/**
 * Retrieve if error should get a feedback on bet-item level.
 */
export const isBetItemNeedToFeedbackAnError = (error: BetslipBetError): boolean =>
	ERROR_TYPES_TO_DISPLAY_ON_BET_OR_BET_ITEM.includes(error.type) && !!error.selectionIds?.length;

/**
 * Sort errors by priority. If error has unavailable type, it will be first in array.
 */
export const sortErrorsByPriority = (errors: BetslipBetError[]): BetslipBetError[] =>
	errors.sort((a, b) => {
		if (a.type === b.type) {
			return 0;
		}
		if (isUnavailableError(a)) {
			return -1;
		}
		return 0;
	});

export const getLimitationToDisplay = (limitations: Array<BetslipLimitation>) =>
	limitations.find(l => LIMITATIONS_TO_DISPLAY.includes(l)) || null;

export const getErrorFromLimitationToDisplay = (
	limitation: BetslipLimitation | null,
	betErrors: Array<BetslipBetError>
) =>
	(limitation === BetslipLimitation.BET_HAS_AN_ERROR &&
		betErrors?.find(bet => BET_ERROR_TYPES_TO_DISPLAY.includes(bet.type))) ||
	null;

export const shouldDisplayLimitation = (limitations: Array<BetslipLimitation>) => {
	const limitation = getLimitationToDisplay(limitations);
	return limitation && limitation !== BetslipLimitation.BET_HAS_AN_ERROR;
};
